import { createRouter, createWebHistory } from 'vue-router'
import RichTextView from '@/views/RichTextView.vue'

const routes = [
  { path: '/', redirect: '/richtext' },
  {
    path: '/richtext',
    name: 'RichText',
    component: RichTextView,
    meta: { title: '赛项详情' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

/** 路由切换后自动更新页面标题，优先使用 meta.title，支持页面动态覆盖 */
router.afterEach((to) => {
  const title = (to.meta?.title as string) || ''
  if (title) document.title = title
})

export default router
